import { useAppEditorFacilityStore } from './editor'

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace GlobalStore {
  export const Editor = {
    getFacilityStore: useAppEditorFacilityStore,
  }
}
